<template>
	<div class="booking-form__section background-lightgray">
		<div class="booking-form__section-wrapper">
			<oh-heading
				:caption="componentName"
				:anchor="componentKebab"
				:selection="headerSelect"
				:canVisible="canIIsVisible"
				@toggleVisibility="toggleVisibility"
			/>

			<transition-expand>
				<div class="booking-form__section-details booking-form__service flex-vertical" v-if="isVisible">
					<div class="b-line b__item b__item-service b-line-yellow flex-horizontal" v-for="(service, i) in services" :key="i">
						<label class="b__item-label flex-vertical">
							<div class="service__label-main flex-horizontal">
								<input
									class="b__item-input"
									v-model="selected[service.inputType]"
									:type="service.inputType"
									:id="`addon_${i}`"
									:name="service.type"
									:value="service.id"
									@click="clickService(service, $event)"
								/>
								<div class="service-header flex-horizontal">
									<span class="service-checkbox"></span>
									<span class="service-name booking-bold">{{ service.name }}</span>
									<span class="service-price booking-regular-nc">{{ $n(service.price, 'currency') }}</span>
								</div>
								<div class="flex-break"></div>
								<div class="service__label-description">
									<div class="service-details__tag-container">
										<div class="service-details__tags booking-small">
											<span class="service-details__tags-item" v-for="(tag, i) in service.tags" :key="i">{{ tag }}</span>
										</div>
										<div class="service-details__tags service-details__tags-secondary booking-small">
											<div class="service-details__tags-item service-details__tags-item-time-icon">
												<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
													<path
														fill-rule="evenodd"
														d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
														clip-rule="evenodd"
													/>
												</svg>
											</div>
											<span class="service-details__tags-item service-details__tags-item-time">{{ service.duration }}min</span>
										</div>
									</div>
									<span class="service-details booking-small">{{ service.description }}</span>
								</div>
							</div>
						</label>
					</div>

					<div class="b-row b-row__service-control">
						<button class="button button__booking button__booking-small centered" @click="next()">{{ $t('continue') }}</button>
					</div>
				</div>
			</transition-expand>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import bookingMixin from '../mixins/booking.mixin'
import OhHeading from './heading'

export default {
	name: 'Addons',

	mixins: [bookingMixin],

	components: { OhHeading },

	data() {
		return {
			original: [],
			selected: {
				radio: null,
				checkbox: [],
			},
		}
	},

	computed: {
		headerSelect() {
			if (this.booking.addons) return this._.map(this._.orderBy(this.booking.addons, 'type'), 'name').join(', ')
			if (this.original) {
				let selected = this.selected.checkbox.concat(this.selected.radio)
				let selectedNames = []
				this._.forEach(this.original, (x) => {
					if (selected.includes(x.id)) selectedNames.push(x.name)
				})
				return selectedNames.join(', ')
			}
			return ''
		},
		barbers() {
			let barbers = this.booking.service.barbers

			this.original.forEach((service) => {
				if (service.id === this.selected.radio || this.selected.checkbox.includes(service.id)) {
					barbers = this._.intersection(barbers, service.barbers)
				}
			})
			return barbers
		},
		services() {
			let services = this._.cloneDeep(this.original)
			services.forEach((service) => {
				service.inputType = service.type === 'other' ? 'checkbox' : 'radio'
			})
			return services
		},
		selectedServices() {
			let services = this._.cloneDeep(this.selected.checkbox)
			if (this.selected.radio) services.push(this.selected.radio)
			return services
		},
	},

	watch: {
		async selectedServices() {
			if (this.currentStep && this.loaded) this.setServices()
		},
	},

	methods: {
		...mapActions({ set: 'booking/setAddons' }),

		async getData() {
			let { data } = await this.$http.get(`/bs/${this.booking.id}/addons`)
			this.original = data.data

			this._.forEach(this.booking.addons, (x) => {
				if (x.type === 'other') this.selected.checkbox.push(x.id)
				else this.selected.radio = x.id
			})
		},

		clickService(service) {
			if (service.id === this.selected.radio) {
				this.selected.radio = null
			}
		},

		async setServices() {
			await this.set(this.selectedServices)
		},

		next() {
			this.nextStep()
		},
	},
}
</script>
